module.exports = __webpack_public_path__ + "static/image1-23c8833276b732add25eac486521ab0a.png";